import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ECONNABORTED') {
      console.error('Timeout:', error.config.url);
    } else if (error.response?.status === 401) {
      localStorage.removeItem("token");
        localStorage.removeItem("exp");
        localStorage.removeItem("store-information");
        localStorage.removeItem("active-store");
      window.location.href = '/';
    } else {
      console.error('Erro Axios:', error);
    }
    return Promise.reject(error);
  }
);

export const copilotAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_COPILOT_API_URL || 'http://localhost:8080',
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json',
  },
});

copilotAxiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

copilotAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ECONNABORTED') {
      console.error('Timeout no Copilot:', error.config.url);
    } else if (error.response?.status === 429) {
      console.error('Limite de requisições do Copilot atingido, tente novamente em instantes.');
    } else if (error.response?.status === 504) {
      console.error('Copilot demorou demais para responder.');
    } else if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("exp");
      localStorage.removeItem("store-information");
      localStorage.removeItem("active-store");
      window.location.href = '/';
    } else {
      console.error('Erro no Copilot:', error);
    }
    return Promise.reject(error);
  }
);